import { render, staticRenderFns } from "./AddEstablishmentInternalOrderPage.vue?vue&type=template&id=2ba97479"
import script from "./AddEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"
export * from "./AddEstablishmentInternalOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports